import React, { Component } from 'react';
import "../../styles/home/home.scss";
import ProgressGraph from "../commoncomponents/progressGraph"

class CardBox extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount(){
       
    }
    
    render() {
       const {name,icon,response,progressValue,progressResponse} = this.props;
        return (
             <div className="card-box ">
                            <div className="card-container outColor">
                                <div className="numeric">
                                    <h1 style={{color:`${this.props.textColor}`}}>{name}</h1>
                                    <div className="numeric-icon">

                                       <i className={icon}></i>
                                    </div>

                                </div>
                                <h2 className="card-top">{response}</h2>
                                <ProgressGraph
                                color={this.props.color}
                                value = {progressValue}
                                response = {progressResponse}
                                />
                       
                            </div>

                        </div>
             
            
            
        );
    }
    
}

export default CardBox;